import { InputProps } from '../types'
import NumberInputBase from './NumberInputBase'

interface AmountInputProps extends InputProps {
  min?: number
  max?: number
  step?: number
  currency?: string
}

/**
 * Renders a currency/amount input field with currency prefix and thousand separator
 * @returns {JSX.Element} The rendered input component.
 */
export default function AmountInput({ onChange, invalid, errorMessage, question, step = 1 }: AmountInputProps) {
  // Format number with thousand separator
  const formatValue = (val: string | number): string => {
    const numStr = String(val)
    if (!numStr || numStr === '') return ''

    // Format with thousand separator
    return Number(numStr).toLocaleString('en-US')
  }

  // Remove thousand separator for parsing
  const parseValue = (val: string): string => {
    return val.replace(/,/g, '')
  }

  return (
    <NumberInputBase
      id={`question-${question.id}`}
      label={question.text}
      value={(question.value as string) ?? ''}
      onChange={onChange}
      step={step}
      required={question.required}
      invalid={!!invalid}
      errorMessage={errorMessage}
      formatValue={formatValue}
      parseValue={parseValue}
    />
  )
}
